import React, { Component } from "react";
import ReactDOM from "react-dom";
import $ from "jquery";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  FormattedMessage,
  FormattedHTMLMessage,
  IntlProvider,
} from "react-intl";
import { history } from "../helper/History";
import Carousel from "react-bootstrap/Carousel";
import ScrollIntoView from "react-scroll-into-view";

class Individual extends Component {
  constructor(props) {
    super(props);
    this.state = {
      state: null,
      roles: [],
      showfirst_card: "",
      alert2: null,
      guide_card: null,
    };
    window.scrollTo(0, 0);
    localStorage.setItem("alert2", null);
  }

  componentDidMount() {
    //const { state } = this.props.location;
    //console.log('Inside Didmount --> '+JSON.stringify(this.props.location)+' -- '+this.props.location.state.from);
    // this.scrollToBottom();
    // if (!sessionStorage.getItem("navigationClick")) {
    //   localStorage.removeItem("navigation");
    // } else {
    //   sessionStorage.removeItem("navigationClick");
    // }
    if (typeof this.props.location.state === "object") {
      // check if type is object
      if (this.props.location.state.from === "home") {
        // check if state.from is home open happiness modal
        $("#happiness").modal(); // show model if it comes from home
      }
    }
  }
  // componentDidUpdate() {
  //   this.scrollToBottom();
  // }

  // scrollToBottom() {
  //   this.el.scrollIntoView({ behavior: 'smooth' });
  // }
  handleClick() {
    const price = "prices123";
    const element = document.getElementById(price);
    console.log(element);
    if (element) {
      // 👇 Will scroll smoothly to the top of the next section

      element.scrollIntoView({ behavior: "smooth" });
    }
  }

  openHappiness() {
    $(".pilotModal").modal("hide");
    localStorage.setItem("testType", "individual"); // set testtyle to localstorage
    history.push("/happiness");
  }
  openTalent() {
    $(".pilotModal").modal("hide");
    localStorage.setItem("testType", "individual"); // set testtyle to localstorage
    history.push("/talent");
  }
  openTarget() {
    $(".pilotModal").modal("hide");
    localStorage.setItem("testType", "individual"); // set testtyle to localstorage
    history.push("/target");
  }
  openSale() {
    $(".pilotModal").modal("hide");
    localStorage.setItem("testType", "individual"); // set testtyle to localstorage
    history.push("/sale");
  }
  openFranchise() {
    $(".pilotModal").modal("hide");
    localStorage.setItem("testType", "individual"); // set testtyle to localstorage
    history.push("/franchise");
  }
  openCreation() {
    $(".pilotModal").modal("hide");
    localStorage.setItem("testType", "individual"); // set testtyle to localstorage
    history.push("/creation");
  }
  buyNowTest() {
    $(".pilotModal").modal("hide");
    localStorage.setItem("testType", "individual"); // set testtyle to localstorage
    history.push("/buy-test?loc=individual");
  }
  getSubscriptionRedirectPath() {
    if (this.props.isSignedIn === null || !this.props.isSignedIn) {
      return "/register";
    }
    console.log("User Role in getSubscriptionRedirectPath: " + localStorage.getItem("userRole"));
    if ( localStorage.getItem("userRole") === "Enterprise") {
        return "/register";
      } else {
        return "/buy-test?loc=individual";
      }
    }

  // open exmplease function
  openHappinessExamples() {
    let lang = this.props.lang;
    const startButtonText1 =
      this.props.lang === "en"
        ? "Start MyHappiness Test"
        : "Démarrer MyHappiness Test";
    const startButtonText2 = this.props.lang === "en" ? "" : "";
    //console.log(lang);
    // "Totally FREE (First signed)" : "Gratuit (première connexion)"
    $(".pilotModal").modal("hide");
    //console.log('loggedIn '+this.props.isSignedIn);
    if (this.props.isSignedIn === null || !this.props.isSignedIn) {
      // $("#loginModal").modal("show");
      history.push("/login");
    } else if (this.props.isSignedIn) {
      //$("#exampleResultTitle").text("Happiness Test Results"); // added title
      $("#testResultData").attr(
        "src",
        "assets/images/individualHappinessResult_" + lang + ".png"
      ); // added happiness example image
      // Add start button below examples
      const happinessButton = (
        <div>
          <div>
            <button
              onClick={this.openHappiness.bind(this)}
              className="btn btn-warning center-block"
            >
              {startButtonText1}
              <br />
              <div className="small">{startButtonText2}</div>
              {/* <FormattedHTMLMessage id="ind.happiness.start.example.button" defaultMessage='Start MyHappiness Test<br /><div className="small">Totally FREE (First signed)</div>'/> */}
            </button>
          </div>
          <div>
            <button
              type="button"
              className="close btn  center-block"
              style={{}}
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      );
      ReactDOM.render(
        <IntlProvider locale={lang}>{happinessButton}</IntlProvider>,
        document.getElementById("startButton")
      );
      $("#myModal").modal("show");
    }
  }

  openTalentExamples() {
    let lang = this.props.lang;
    const startButtonText =
      this.props.lang === "en"
        ? "Start MyTalent Test"
        : "Démarrer MyTalent Test";

    $(".pilotModal").modal("hide");
    if (this.props.isSignedIn === null || !this.props.isSignedIn) {
      // $("#loginModal").modal("show");
      history.push("/login");
    } else if (this.props.isSignedIn) {
      //$("#exampleResultTitle").text("Talent Test Results"); // added title
      $("#testResultData").attr(
        "src",
        "assets/images/individualTalentResult_" + lang + ".png"
      );
      // Add start button below examples
      const talentButton = (
        <div>
          <div>
            <button
              onClick={this.openTalent.bind(this)}
              className="btn btn-warning center-block"
            >
              {startButtonText}
            </button>
          </div>
          <div>
            <button
              type="button"
              className="close btn  center-block"
              style={{}}
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      );
      ReactDOM.render(talentButton, document.getElementById("startButton"));
      $("#myModal").modal("show");
    }
  }

  openTargetExamples() {
    let lang = this.props.lang;
    const startButtonText =
      this.props.lang === "en"
        ? "Start MyTarget Test"
        : "Démarrer MyTarget Test";

    $(".pilotModal").modal("hide");
    if (this.props.isSignedIn === null || !this.props.isSignedIn) {
      // $("#loginModal").modal("show");
      history.push("/login");
    } else if (this.props.isSignedIn) {
      //$("#exampleResultTitle").text("Target Test Results"); // added title
      $("#testResultData").attr(
        "src",
        "assets/images/individualTargetResult_" + lang + ".png"
      );
      // Add start button below examples
      const targetButton = (
        <div>
          <div>
            <button
              onClick={this.openTarget.bind(this)}
              className="btn btn-warning center-block"
            >
              {startButtonText}
            </button>
          </div>
          <div>
            <button
              type="button"
              className="close btn  center-block"
              style={{}}
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      );
      ReactDOM.render(targetButton, document.getElementById("startButton"));
      $("#myModal").modal("show");
    }
  }

  
  openSaleExamples() {
    let lang = this.props.lang;
    const startButtonText =
      this.props.lang === "en" ? "Start MySales Test" : "Démarrer MySales Test";

    //console.log('Inside openSaleExamples');
    $(".pilotModal").modal("hide");
    if (this.props.isSignedIn === null || !this.props.isSignedIn) {
      // $("#loginModal").modal("show");
      history.push("/login");
    } else if (this.props.isSignedIn) {
      //console.log('Inside else');
      //$("#exampleResultTitle").text("Sale Test Results"); // added title
      $("#testResultData").attr(
        "src",
        "assets/images/individualSaleResult_" + lang + ".png"
      );
      // Add start button below examples
      const saleButton = (
        <div>
          <div>
            <button
              onClick={this.openSale.bind(this)}
              className="btn btn-warning center-block"
            >
              {startButtonText}
            </button>
          </div>
          <div>
            <button
              type="button"
              className="close btn  center-block"
              style={{}}
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      );
      ReactDOM.render(saleButton, document.getElementById("startButton"));
      $("#myModal").modal("show");
    }
  }
  openCreationExamples() {
    let lang = this.props.lang;
    const startButtonText =
      this.props.lang === "en"
        ? "Start MyCreation Test"
        : "Démarrer MyCreation Test";
    $(".pilotModal").modal("hide");
    if (this.props.isSignedIn === null || !this.props.isSignedIn) {
      // $("#loginModal").modal("show");
      history.push("/login");
    } else if (this.props.isSignedIn) {
      //$("#exampleResultTitle").text("Creation Test Results"); // added title
      $("#testResultData").attr(
        "src",
        "assets/images/individualCreationResult_" + lang + ".png"
      );
      // Add start button below examples
      const entrepreneurButton = (
        <div>
          <div>
            <button
              onClick={this.openCreation.bind(this)}
              className="btn btn-warning center-block"
            >
              {startButtonText}
            </button>
          </div>
          <div>
            <button
              type="button"
              className="close btn  center-block"
              style={{}}
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      );
      ReactDOM.render(
        entrepreneurButton,
        document.getElementById("startButton")
      );
      $("#myModal").modal("show");
    }
  }
  handleclick() {
    const price = "prices123";
    const element = document.getElementById(price);
    console.log(element);
    if (element) {
      // 👇 Will scroll smoothly to the top of the next section

      element.scrollIntoView({ behavior: "smooth" });
    }
  }
  handleButton() {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }

  openFranchiseExamples() {
    let lang = this.props.lang;
    const startButtonText =
      this.props.lang === "en"
        ? "Start MyFranchise Test"
        : "Démarrer MyFranchise Test";
    $(".pilotModal").modal("hide");
    if (this.props.isSignedIn === null || !this.props.isSignedIn) {
      // $("#loginModal").modal("show");
      history.push("/login");
    } else if (this.props.isSignedIn) {
      //$("#exampleResultTitle").text("Franchise Test Results"); // added title
      $("#testResultData").attr(
        "src",
        "assets/images/IndividualFranchiseResult_" + lang + ".png"
      );
      // Add start button below examples
      const franchiseButton = (
        <div>
          <div>
            <button
              onClick={this.openFranchise.bind(this)}
              className="btn btn-warning center-block"
            >
              {startButtonText}
            </button>
          </div>
          <div>
            <button
              type="button"
              className="close btn  center-block"
              style={{}}
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      );
      ReactDOM.render(franchiseButton, document.getElementById("startButton"));
      $("#myModal").modal("show");
    }
  }

  errMessage() {
    setTimeout(() => {
      // Remove the item from localStorage after the specified time

      localStorage.removeItem("guide");
    }, 400000);

    return (
      <div
        class="alert alert-success alert-dismissible fade show "
        role="alert"
      >
        <FormattedHTMLMessage id="alert5" />
        <button
          type="button"
          class="close"
          onClick={(e) => localStorage.removeItem("guide")}
          data-dismiss="alert"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    );
    // setTimeout(() => {
    //   this.props.clearMessage();
    // }, 25000);
  }

  showAlert() {
    localStorage.removeItem("alert9", "1");
    localStorage.removeItem("alert2", "null");
    localStorage.removeItem("alert2", "5");
  }
    showAlert5() {
    localStorage.removeItem("alert9", "1");
    localStorage.removeItem("alert2", "null");
    localStorage.setItem("alert2", "5");
    }

  // PRH SAFE ADDITION START: Individual credit cards layout for all test modals
  renderIndividualCreditCards() {
    const userRole = localStorage.getItem("userRole");

    if (!userRole || userRole !== "Individual") {
      return null;
    }
    const creditCards = [
      {
        key: "10",
        titleId: "individual.credit_modal.card1.title",
        titleDefault: "10 credits",
        priceId: "individual.credit_modal.card1.price",
        priceDefault: "€29.90 excl. VAT / credit",
        validId: "individual.credit_modal.card1.valid",
        validDefault: "valid 12 months",
        assessmentId: "individual.credit_modal.card1.assessment",
        assessmentDefault: "All assessment",
        vatId: "individual.credit_modal.card1.vat",
        vatDefault: "VAT 20%",
      },
      {
        key: "25",
        titleId: "individual.credit_modal.card2.title",
        titleDefault: "25 credits",
        priceId: "individual.credit_modal.card2.price",
        priceDefault: "€23.96 excl. VAT / credit",
        validId: "individual.credit_modal.card2.valid",
        validDefault: "valid 12 months",
        assessmentId: "individual.credit_modal.card2.assessment",
        assessmentDefault: "All assessment",
        vatId: "individual.credit_modal.card2.vat",
        vatDefault: "VAT 20%",
      },
      {
        key: "50",
        titleId: "individual.credit_modal.card3.title",
        titleDefault: "50 credits",
        priceId: "individual.credit_modal.card3.price",
        priceDefault: "€19.98 excl. VAT / credit",
        validId: "individual.credit_modal.card3.valid",
        validDefault: "valid 12 months",
        assessmentId: "individual.credit_modal.card3.assessment",
        assessmentDefault: "All assessment",
        vatId: "individual.credit_modal.card3.vat",
        vatDefault: "VAT 20%",
      },
    ];

    return (
      <div className="indi-list prh-individual-credit-cards-layout">
        <div className="prh-individual-credit-cards-title">
          <FormattedHTMLMessage
            id="individual.credit_modal.title"
            defaultMessage="ADD CREDITS"
          />
        </div>
        <div className="prh-individual-credit-cards-grid">
          {creditCards.map((card) => (
            <div className="prh-individual-credit-card" key={card.key}>
              <div className="prh-individual-credit-card-title">
                <FormattedHTMLMessage
                  id={card.titleId}
                  defaultMessage={card.titleDefault}
                />
              </div>
              <div className="prh-individual-credit-card-price">
                <FormattedHTMLMessage
                  id={card.priceId}
                  defaultMessage={card.priceDefault}
                />
              </div>
              <p className="prh-individual-credit-card-meta">
                <FormattedHTMLMessage
                  id={card.validId}
                  defaultMessage={card.validDefault}
                />
              </p>
              <p className="prh-individual-credit-card-meta">
                <FormattedHTMLMessage
                  id={card.assessmentId}
                  defaultMessage={card.assessmentDefault}
                />
              </p>
              <p className="prh-individual-credit-card-meta">
                <FormattedHTMLMessage
                  id={card.vatId}
                  defaultMessage={card.vatDefault}
                />
              </p>
              <button
                type="button"
                className="prh-individual-credit-card-button"
                onClick={this.buyNowTest.bind(this)}
              >
                <FormattedHTMLMessage
                  id="individual.credit_modal.cta"
                  defaultMessage="Credit your account"
                />
              </button>
            </div>
          ))}
        </div>
      </div>
    );
  }
  // PRH SAFE ADDITION END

  render() {
    const userRole = localStorage.getItem("userRole");
    const navigate = localStorage.getItem("navigation");
    return (
      <React.Fragment>
        <section id="carousel-wrapper" className="Individual">

          <div className="col-md-12 text-center margin-row-top">
            <div className="row margin-row-1 prh-ind-top-role-tariff-row">

              <div className="col-md-6 individual-top-role-card-col">
              {userRole && (
                 <Link
                    className="btn btn-primary p-link"
                    to={ navigate === "skills" ? "/youareaconsultant" : navigate === "enterprise" ? "/youareacompany" : "/individual"}
                    
                    style={{
                      background: "#28326a",
                    
                      marginTop: "5%",
                      width: "324px",
                    
                      border: "none",
                    }}
                  >
                    
                    <p className="demo-btn">
                      {" "}
                      <FormattedHTMLMessage
                        id={userRole === "User" ? "sub.menue" : userRole === "Hr" ? "sub.menue1" : userRole === "Enterprise" ? "sub.menue2" : "sub.menue"}
                        defaultMessage="FAQ"
                      />
                    </p>
                  </Link>
              )}
                
              </div>
              {userRole == "Enterprise" && (
                <div className="col-md-6 individual-top-tariff-col">
                  <Link to="/corporate-tarrif" style={{ color: "white", textDecoration: "none" }} >
                    <div className="white-btn hero-btn banner-button-title-2" style={{}} >
                      <FormattedHTMLMessage
                        id="individual.tarrif.link"
                        defaultMessage="<p className='pb-1 mb-0'> €350 VAT included <span className='small'>instead of <del>450 €</del></span></p>"
                      />
                    </div>
                  </Link>
                </div>
              )}
            </div>

            <div className="row margin-row-2" >

              <div className="col-md-8 individual-hero-center-col">
                <div className="intro_layer individual_center_card" data-animation="fadeIn"> 
                  <h2 className="text-uppercase intro_featured_word mt-4">
                      <b>
                        <FormattedHTMLMessage
                          id={userRole === "Enterprise" ? "individual.ul.title.business" : userRole === "User" ? "individual.ul.title.business" : navigate === "skills" ? "company.ind.heading" : "individual.ul.title.business"}
                        />
                        
                      </b>
                  </h2>
                    {!userRole && userRole && userRole !== "Hr" && navigate === "skills" &&(
                    <h3>  
                      <FormattedHTMLMessage
                          id="company.ind.subheading"
                          defaultMessage="Assess your talents and target jobs"
                        />
                    </h3>
                     )} 
                  <div className="custom_box">
                    {localStorage.getItem("guide") == 1 ? (this.errMessage()
                    ) : (
                      <div className="intro-parent" style={{ display: this.state.guide_card }}>
                        <div className="intro_layer animate animated fadeFromTop banner-button-title-individual" data-animation="fadeInLeft" style={{}}>
                        
                          <p className= {navigate === "skills" ? "text-left" : "text-center"}>
                            {" "}
                            <FormattedHTMLMessage
                              id={userRole === "Enterprise" ? "individual.ul.business" : userRole === "User" ? "individual.ul.business" : navigate === "skills" ? "individual.ul" : "individual.ul.business"}
                            />{" "}
                          </p>
                          
                        </div>
                     {navigate === "skills" ? (
                        <div className="individual-skills-content">
                          <FormattedHTMLMessage id="individual.ul.skills" />
                        </div>
                      ) : navigate === "enterprise" ? (
                        <div className="individual-skills-content">
                          <FormattedHTMLMessage id="individual.ul.outplacement" />
                        </div>
                      ) : (
                        ""
                      )}

                        {/* <div className="add-width intro-child-button">

                          <div
                            className="hero-center-btn box-button-text"
                            style={{

                            }}
                          >
                            <div>
                              <FormattedHTMLMessage
                                id={userRole === "User" ? "skill.test.btn.content" : "skill.test.btn.content.business"}
                              />
                            </div>
                            <div
                              className="contact-btn-individual banner-individual-text"
                              style={{}}
                            >
                              <Link
                                to="/contact-us"
                                className="banner-individual-text-2"

                                style={{}}
                              >
                                <FormattedHTMLMessage
                                  id={userRole === "User" ? "individual.calendly.button" : "individual.calendly.button.business"}
                                />
                              </Link>
                            </div>
                          </div>

                        </div> */}

                      </div>
                    )}



                  </div>
                </div>
              </div>
              
              <div className="col-md-2 individual_pdf_wrapper">
                <div className="client-btn-wrapper" style={{ display:"none"}}>



                  <a href="/assets/pdf/PILOTRH_PARTICULIER.pdf" style={{ textDecoration: "none" }} target="_blank">
                    <div class="client-btn banner-button-title-4" style={{}}>
                      <b>
                        <p style={{ marginBottom: "0px", color: "black" }}>
                          {" "}
                          <FormattedHTMLMessage
                            id="individual_pdf1"
                            defaultMessage="FAQ"
                          />
                        </p>
                      </b>
                      <img
                        className="oliver-img banner-pdf-img"
                        src="assets/images/pdf.jpg"
                        style={{}}
                      ></img>


                    </div>
                  </a>



                </div>
              </div>
            </div>

            {/* <div className="row margin-row-3" >
              <div className="col-md-12">

                <div
                  className="white-btn hero-btn full-width-text"
                  style={{

                  }}
                >
                  <Link style={{ color: "white", textDecoration: "none", }} >
                    <div>
                      <FormattedHTMLMessage
                        id={userRole === "User" ? "individual.banner_button" : "individual.banner_button.business"}
                      />
                    </div>
                  </Link>
                </div>
              </div>
            </div> */}


          </div>





          {/* <div className="demo-btn-block">
            <Link onClick={this.handleButton()}></Link>
            <div
              className="white-btn"
              style={{
                backgroundColor: "#003366",
                color: "white",
                borderRadius: "5px",
              }}
              onClick={this.showAlert}
            >
              <div>
                <Link to="/register" style={{ color: "white" }}>
                  <FormattedHTMLMessage
                    id="replace.tarif.indi"
                    defaultMessage="<p className='pb-1'> €350 VAT included <span className='small'>instead of <del>450 €</del></span></p>"
                  />
                </Link>
              </div>
            </div>
          </div> */}

          {/* <div className="demo-btn-block">
            <Link onClick={this.handleButton()}></Link>
            <div
              className="white-btn"
              style={{ backgroundColor: '#003366', color: 'white' ,marginTop:"9%" }}
            > */}

          {/* <ScrollIntoView selector="#prices123">
         
            <button
              // onClick={this.handleclick()}
              className="white-btn"
              style={{
                backgroundColor: "#003366",
                color: "white",
                border: "none",
                marginTop: "5%",
                borderRadius: "5px",
              }}
            >
              <FormattedHTMLMessage
                id="tarifs"
                defaultMessage="<p className='pb-1'> €350 VAT included <span className='small'>instead of <del>450 €</del></span></p>"
              />
            </button>
            
          </ScrollIntoView> */}




        </section>

    <section className="individual-test prh-credit-safe-test-gap" id="indvidual-block">
      
    {userRole === "User" ? 
      <Link
        to={this.getSubscriptionRedirectPath()}
        className="prh-credit-account-button"
        onClick={this.showAlert()}
      >
        <FormattedHTMLMessage id="ind.button.tile" defaultMessage="Credit your account"/> 
      </Link>
   

     : 
      <Link
        to={navigate === "skills" ? "/create-link" : navigate === "enterprise" ? "#" : userRole ==="user" ? "/buy-test" : "/register"}
        className="prh-credit-account-button" onClick={this.showAlert()}
      >
        <FormattedHTMLMessage id={navigate === "individual" ? "ind.button.tile"  : navigate === "enterprise" ? "ind.button.tile" : "ind.credittitle2"} defaultMessage="Credit your account"/> 
      </Link>
     
     
     
     
     }
      
      
      
      
      </section>

        {/* <div id="section1"> */}
        <section className="individual-test" id="indvidual-block">

          <div className="container-fluid p-0">
            <div className="add-width intro_layer" data-animation="fadeIn">
              <div className="d-block">
                <div className="indi-tests">
                  <ul className="services-list">
                    <li style={{ backgroundColor: "white", color: "black" }}>
                      <button
                        data-animation="fadeIn"
                        data-toggle="modal"
                        data-target="#happiness"
                        className="btn"
                      >
                        {/* <img src="assets/images/smile-1.png" alt="" /> */}
                        <span style={{ color: "#18B6CE" }}>
                          <FormattedHTMLMessage
                            id="indi.cardtitle1"
                            defaultMessage="TOOL"
                          />
                        </span>{" "}
                        <br />
                        {/* <FormattedMessage
                          id="test_capital"
                          defaultMessage="TEST"
                        /> */}
                        <p>
                          <FormattedHTMLMessage
                            id="free_first_connection"
                          />
                        </p>
                        {/* <p style={{ color: "#18B6CE", marginTop: "-15px", fontWeight: "bold" }}>
                          <FormattedHTMLMessage
                            id="individual.card1.credit"
                          />
                        </p> */}
                      </button>
                    </li>
                    <li style={{ backgroundColor: "white", color: "black" }}>
                      <button
                        data-toggle="modal"
                        data-target="#talent"
                        className="btn"
                      >
                        <span style={{ color: "#18B6CE" }}>
                          <FormattedHTMLMessage
                            id="indi.cardtitle2"
                            defaultMessage="TOOL"
                          />
                        </span>{" "}
                        <br />
                        {/* <FormattedMessage
                          id="test_capital"
                          defaultMessage="TEST"
                        /> */}
                        <p>
                          <FormattedHTMLMessage
                            id="free_second_test"
                          />
                        </p>
                        {/* <p style={{ color: "#18B6CE", marginTop: "-15px", fontWeight: "bold" }}>
                          <FormattedHTMLMessage
                            id="individual.card2.credit"
                          />
                        </p> */}
                      </button>
                    </li>
                    <li style={{ backgroundColor: "white", color: "black" }}>
                      <button
                        data-toggle="modal"
                        data-target="#target"
                        className="btn"
                      >
                        <span style={{ color: "#18B6CE" }}>
                          <FormattedHTMLMessage
                            id="indi.cardtitle3"
                            defaultMessage="TOOL"
                          />
                        </span>{" "}
                        <br />
                        {/* <FormattedMessage
                          id="test_capital"
                          defaultMessage="TEST"
                        /> */}
                        <p>
                          <FormattedHTMLMessage
                            id="free_third_test"
                          />
                        </p>
                        {/* <p style={{ color: "#18B6CE", marginTop: "-15px", fontWeight: "bold" }}>
                          <FormattedHTMLMessage
                            id="individual.card3.credit"
                          />
                        </p> */}
                      </button>
                    </li>
                    <li style={{ backgroundColor: "white", color: "black" }}>
                      <button
                        data-toggle="modal"
                        data-target="#sale"
                        className="btn"
                      >
                        <span style={{ color: "#18B6CE" }}>
                          <FormattedHTMLMessage
                            id="indi.cardtitle4"
                            defaultMessage="TOOL"
                          />
                        </span>{" "}
                        <br />
                        {/* <FormattedMessage
                          id="test_capital"
                          defaultMessage="TEST"
                        /> */}
                        <p>
                          <FormattedHTMLMessage
                            id="free_fourth_test"
                          />
                        </p>
                        {/* <p style={{ color: "#18B6CE", marginTop: "-15px", fontWeight: "bold" }}>
                          <FormattedHTMLMessage
                            id="individual.card4.credit"
                          />
                        </p> */}
                      </button>
                    </li>
                    <li style={{ backgroundColor: "white", color: "black" }}>
                      <button
                        data-toggle="modal"
                        data-target="#enterprise"
                        className="btn"
                      >
                        <span style={{ color: "#18B6CE" }}>
                          <FormattedHTMLMessage
                            id="indi.cardtitle5"
                            defaultMessage="TOOL"
                          />
                        </span>{" "}
                        <br />
                        {/* <FormattedMessage
                          id="test_capital"
                          defaultMessage="TEST"
                        /> */}
                        <p>
                          <FormattedHTMLMessage
                            id="free_five_test"
                          />
                        </p>
                        {/* <p style={{ color: "#18B6CE", marginTop: "-15px", fontWeight: "bold" }}>
                          <FormattedHTMLMessage
                            id="individual.card5.credit"
                          />
                        </p> */}
                      </button>
                    </li>
                    <li style={{ backgroundColor: "white", color: "black" }}>
                      <button
                        data-toggle="modal"
                        data-target="#FRANCHISE"
                        className="btn"
                      >
                        <span style={{ color: "#18B6CE" }}>
                          <FormattedHTMLMessage
                            id="indi.cardtitle6"
                            defaultMessage="TOOL"
                          />
                        </span>{" "}
                        <br />
                        {/* <FormattedMessage
                          id="test_capital"
                          defaultMessage="TEST"
                        /> */}
                        <p>
                          <FormattedHTMLMessage
                            id="free_six_test"
                          />
                        </p>
                        {/* <p style={{ color: "#18B6CE", marginTop: "-15px", fontWeight: "bold" }}>
                          <FormattedHTMLMessage
                            id="individual.card6.credit"
                          />
                        </p> */}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* </div> */}
       
        
        <section
          className="icon-boxed1 teaser-box mt-10 individual-section"
          id="prices123" 
         style={{ display: userRole === "Hr" ? "none" : navigate === "skills" ? "none" : "block" }}
        >
          <div className="container">
            <div className="row">
              <p className="text-center w-100 mb-5">
                <FormattedHTMLMessage
                  id={userRole === "User" ? "online.test.indi.heading.user" : "online.test.indi.heading"}
                  defaultMessage="All subscriptions provide access to all tools and can be recharged with credits at any time."
                />
              </p>

              <div className="col-lg-4 col-md-4 responsive-mb">
                <div className="icon-box indvidual-boxes text-center hero-bg box-shadow">
                  <div>
                    <p>
                      {/* <Link to="/" className=""> */}
                      <FormattedHTMLMessage
                        id={userRole === "User" ? "online.test.heading.user" : "online.test.heading"}
                        defaultMessage="starter"
                      />
                      {/* </Link> */}
                    </p>

                    <div className="HalfBordr mt-1">
                      {/* <p>
                        <FormattedHTMLMessage
                          id={userRole === "User" ? "online.free.user" : "online.free"}
                          defaultMessage="12 months"
                        />
                      </p> */}

                      <FormattedHTMLMessage
                        id="online.price.user" 
                        defaultMessage="12 months"
                      />

                      <p className="mt-0">
                        <FormattedHTMLMessage
                          id= "online.free.sub.user" 
                          defaultMessage="12 months"
                        />
                      </p>
                    </div>
                    {/* <p className="mt-0">
                        <FormattedHTMLMessage
                          id="online.free.subs"
                          defaultMessage="12 months"
                        />
                      </p> */}
                  </div>
                  <div>
                    <Link
                      to={this.getSubscriptionRedirectPath()}
                      className="nav-link"
                      data-target=".navbar-collapse.show"
                    >
                      <button
                        class="btn btn-primary br_remove"
                        style={{
                          background: "#18B6CE",
                          border: "none",
                          marginTop: "100px",
                        }}
                        onClick={this.showAlert5.bind(this)}
                      >
                        <FormattedHTMLMessage
                          id="individual.calendly.button1"
                          defaultMessage="Subscribe"
                        />
                      </button>
                    </Link>
                  </div>
                  <div>
                    <Link
                      to={this.getSubscriptionRedirectPath()}
                      className="nav-link"
                      data-target=".navbar-collapse.show"
                    >
                      <button
                        class="btn btn-primary br_remove"
                        style={{
                          background: "rgb(52 58 64)",
                          border: "none",
                          marginTop: "30px",
                        }}
                        onClick={this.showAlert5.bind(this)}
                      >
                        <FormattedHTMLMessage
                          id="individual.calendly.button1_last"
                          defaultMessage="Subscribe"
                        />
                      </button>
                    </Link>
                  </div>
                  {/* {userRole !== "User" && (
                    <div>
                      <Link
                        to="/corporate-tarrif"
                        className="nav-link"
                        data-target=".navbar-collapse.show"
                      >
                        <button
                          class="btn btn-primary br_remove"
                          style={{
                            background: "#ffc107",
                            color: "black",
                            border: "none",
                            marginTop: "30px",
                          }}
                          onClick={this.showAlert}
                        >
                          <FormattedHTMLMessage
                            id={
                              userRole === "User"
                                ? "individual.calendly.button2_last.user"
                                : "individual.calendly.button2_last"
                            }
                            defaultMessage="Subscribe"
                          />
                        </button>
                      </Link>
                    </div>
                  )} */}
                </div>
              </div>

              <div className="col-lg-4 col-md-4 responsive-mb">
                <div className="icon-box indvidual-boxes text-center hero-bg box-shadow">
                  <div>
                    <p>
                      <FormattedHTMLMessage
                        id= "career.point.user"
                        defaultMessage="Classic"
                      />
                    </p>

                    <div className="HalfBordr mt-1">
                      {/* <p>
                        <FormattedHTMLMessage
                          id={userRole === "User" ? "career.heading.user" : "career.heading"}
                          defaultMessage="€49.90"
                        />
                      </p> */}

                      <FormattedHTMLMessage
                        id="career.price.user" 
                        defaultMessage="per month - annual payment"
                      />

                      <p className="mt-1">
                        <FormattedHTMLMessage
                          id="career.price.sub.user" 
                          defaultMessage="per month - annual payment"
                        />
                      </p>
                    </div>

                    {/* <p>
                    <FormattedHTMLMessage
                      id="uploading.sub.2"
                      defaultMessage="per month - annual payment"
                    />
                    </p>

                    <p>
                    <FormattedHTMLMessage
                      id="uploading.sub3"
                      defaultMessage="per month - annual payment"
                    />
                    </p> */}

                    {/* <p><FormattedHTMLMessage id="Starter.user" defaultMessage="1 user" /></p>    */}
                  </div>

                  <div>
                    <Link
                      to={this.getSubscriptionRedirectPath()}
                      className="nav-link"
                      data-target=".navbar-collapse.show"
                    >
                      <button
                        class="btn btn-primary br_remove"
                        style={{
                          background: "#18B6CE",
                          border: "none",
                          marginTop: "30px",
                          textDecoration: "none",
                        }}
                        onClick={this.showAlert5.bind(this)}
                      >
                        <FormattedHTMLMessage
                          id="individual.calendly.button2"
                          defaultMessage="Subscribe"
                        />
                      </button>
                    </Link>
                  </div>

                  <div>
                    <Link
                      to={this.getSubscriptionRedirectPath()}
                      className="nav-link"
                      data-target=".navbar-collapse.show"
                    >
                      <button
                        class="btn btn-primary br_remove"
                        style={{
                          background: "rgb(52 58 64)",
                          border: "none",
                          marginTop: "30px",
                        }}
                        onClick={this.showAlert5.bind(this)}
                      >
                        <FormattedHTMLMessage
                          id="individual.calendly.button1_last"
                          defaultMessage="Subscribe"
                        />
                      </button>
                    </Link>
                  </div>
                  {/* {userRole !== "User" && (
                    <div>
                      <Link
                        to="/corporate-tarrif"
                        className="nav-link"
                        data-target=".navbar-collapse.show"
                      >
                        <button
                          class="btn btn-primary br_remove"
                          style={{
                            background: "#ffc107",
                            color: "black",
                            border: "none",
                            marginTop: "30px",
                          }}
                          onClick={this.showAlert}
                        >
                          <FormattedHTMLMessage
                            id={
                              userRole === "User"
                                ? "individual.calendly.button2_last.user"
                                : "individual.calendly.button2_last"
                            }
                            defaultMessage="Subscribe"
                          />
                        </button>
                      </Link>
                    </div>
                  )} */}
                </div>
              </div>

              <div className="col-lg-4 col-md-4 responsive-mb">
                <div className="icon-box text-center indvidual-boxes hero-bg box-shadow ">
                  <div>
                    <h3>
                      <FormattedHTMLMessage
                        id="full.heading.user"
                        defaultMessage="Classic"
                      />
                    </h3>

                    <div className="HalfBordr mt-4">
                      {/* <p>
                        <FormattedHTMLMessage
                          id={userRole === "User" ? "fullass.sub.user" : "fullass.sub"}
                          defaultMessage="€49.90"
                        />
                      </p> */}
                      <FormattedHTMLMessage
                        id="full.price.user" 
                        defaultMessage="per month - annual payment"
                      />

                      <p className="mt-0">
                        <FormattedHTMLMessage
                          id="full.price.sub.user" 
                          defaultMessage="per month - annual payment"
                        />
                      </p>
                    </div>
                    {/* <p><FormattedHTMLMessage id="Starter.user" defaultMessage="1 user" /></p>    */}
                  </div>
                  <div>
                    <Link
                      to={this.getSubscriptionRedirectPath()}
                      className="nav-link"
                      data-target=".navbar-collapse.show"
                    >
                      <button
                        class="btn btn-primary br_remove"
                        style={{
                          background: "#18B6CE",
                          border: "none",
                          marginTop: "30px",
                          textDecoration: "none",
                        }}
                        onClick={this.showAlert5.bind(this)}
                      >
                        <FormattedHTMLMessage
                          id="individual.calendly.button2"
                          defaultMessage="Subscribe"
                        />
                      </button>
                    </Link>
                  </div>
                  <div>
                    <Link
                      to={this.getSubscriptionRedirectPath()}
                      className="nav-link"
                      data-target=".navbar-collapse.show"
                    >
                      <button
                        class="btn btn-primary br_remove"
                        style={{
                          background: "rgb(52 58 64)",
                          border: "none",
                          marginTop: "30px",
                        }}
                        onClick={this.showAlert5.bind(this)}
                      >
                        <FormattedHTMLMessage
                          id="individual.calendly.button1_last"
                          defaultMessage="Subscribe"
                        />
                      </button>
                    </Link>
                  </div>
                  {/* {userRole !== "User" && (
                    <div>
                      <Link
                        to="/corporate-tarrif"
                        className="nav-link"
                        data-target=".navbar-collapse.show"
                      >
                        <button
                          class="btn btn-primary br_remove"
                          style={{
                            background: "#ffc107",
                            color: "black",
                            border: "none",
                            marginTop: "30px",
                          }}
                          onClick={this.showAlert}
                        >
                          <FormattedHTMLMessage
                            id={
                              userRole === "User"
                                ? "individual.calendly.button2_last.user"
                                : "individual.calendly.button2_last"
                            }
                            defaultMessage="Subscribe"
                          />
                        </button>
                      </Link>
                    </div>
                  )} */}
                </div>
              </div>



            </div>
          </div>
        </section>
        <div
          className="modal fade pilotModal"
          id="myModal"
        // data-backdrop="static"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-secondary">
                <h4 className="modal-title text-center text-uppercase w-100 medium text-white font-20">
                  <FormattedMessage
                    id="result.example.title"
                    defaultMessage="Example of Results"
                  />
                </h4>
                <button type="button" className="close" data-dismiss="modal">
                  ×
                </button>
              </div>
              <div className="modal-body">
                {/* <h5 className="text-center mb-4" id="exampleResultTitle">Happiness Test Results</h5> */}
                <img
                  src="assets/images/happinessResult.png"
                  className="img-fluid w-100"
                  id="testResultData"
                  alt="Happiness Test Result"
                />
                <div className="d-table m-auto">
                  <div className="d-inline-block" id="startButton"></div>
                </div>
                {/* <div className="text-center p-0 small">
                    <p> © Copyright 5W PILOT RH SOLUTIONS {CopyrightDate.getFullYear()} – All right reserved – www.pilotrhsolutions.com.</p>
                </div> */}
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade pilotModal"
          id="happiness"
        // data-backdrop="static"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-secondary">
                <h4 className="modal-title text-center text-uppercase w-100 medium text-white font-20">
                  MyHappiness Test
                </h4>
                <button type="button" className="close" data-dismiss="modal">
                  ×
                </button>
              </div>

              <div className="modal-body">
                <div className="">
                  <div className="about" id="services">
                    <div className="text-justify">
                      <div
                        className="animate animated slideInLeft"
                        data-animation="slideInLeft"
                      >
                        <h2 className="about-title text-left">
                          <FormattedHTMLMessage
                            id="ind.happiness.popup.title"
                            defaultMessage="MyHappiness Test: Measure your job happiness."
                          />
                        </h2>
                      </div>
                      <div className="d-flex m-auto w-100">
                        <div className="d-inline-block w-50">
                          <button
                            onClick={this.openHappinessExamples.bind(this)}
                            className="btn btn-warning center-block example_button_radius"
                            style={{
                              backgroundColor: "#191970",
                              color: "white",
                            }}
                          >
                            <FormattedHTMLMessage
                              id="ind.happiness.btn.examples"
                              defaultMessage="SEE EXAMPLE OF RESULTS"
                            />
                          </button>
                        </div>
                        <div className="d-inline-block w-50">
                          <button
                            onClick={this.openHappiness.bind(this)}
                            className="btn center-block example_button_radius"
                            style={{
                              backgroundColor: "#1ca9c9",
                              color: "white",
                            }}
                          >
                            <FormattedHTMLMessage
                              id="ind.happiness.btn.start"
                              defaultMessage="Start MyHappiness Test <br/> <div class='small'> Totally FREE (First signed) </div>"
                            />
                          </button>
                        </div>
                        <div className="d-inline-block w-50">
                          <button
                            className="btn btn-warning"
                            style={{
                              backgroundColor: "#191970",
                              color: "white",
                            }}
                            onClick={this.buyNowTest.bind(this)}
                          >
                            <FormattedHTMLMessage
                              id="ind.happiness.btn.first.signed"
                              defaultMessage="Start Buy Now"
                            />
                            {/* FREE <small>(First Signed)</small> */}
                          </button>
                        </div>
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.happiness.p.duration"
                          defaultMessage="<h3>Duration</h3><ul className='indi-ul'> <li>40 questions – 7 minutes.</li></ul>"
                        />
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.happiness.p.resultlist"
                          defaultMessage="<h3 class=''>Results </h3> <ul class='indi-ul'> <li> Your satisfaction at work compare to the average.</li><li> Your satisfaction on eight key factors of balance and development at work.{' '}</li><li>What you can still improved to be happier. </li></ul>"
                        />
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.happiness.p.help"
                          defaultMessage="<h3 class=''>Help </h3> <ul class='indi-ul'> <li>Prepare a professional interview. </li><li> Identify reasons of a possible malaise or weariness. </li><li>Decide on internal ot external mobility. </li></ul>"
                        />
                      </div>

                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.happiness.p.research"
                          defaultMessage="<h3 class=''>Scientific-Researches </h3> <p class='modal-text'> MEASURE OF HAPPINESS AT WORK : </p><p class='pl-3'> Business life brings people together to ensure the best possible performance. Some of conditions must be met for everyone to flourish. </p><p class='pl-3'> <b class='title_italic'>MyHAPPINESS TEST©</b> highlights your level of happiness in your job through eight factors of balance and development at work : Freedom of exchange, Possibility of expressing one's wishes, Personal action, Career follow-up, Possibility of working at one's own rate, Accomplishment of a work of freedom, identity, and purpose in your work. </p><p class='pl-3 reconmendFontSize'> <u>Recommended reading:</u> SAINSAULIEU Renaud. <i>Identité au travail</i>. Paris. Ed. Presse de la Fondation des Sciences Politiques. 1988.. </p>"
                        />
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.happiness.p.start.test"
                          defaultMessage="<h3 class=''>Start Your Test </h3> <div class='about-text'> <p> Before starting ‘My HAPPINESS test’ you can see an example of results exactly as you will get after taking. Your test still totally confidential and we don’t use any named data coming from you for other destination of the test (French Data Authority n°661001)</p></div>"
                        />
                        <div
                          className="add-width intro_layer mt-5 d-flex"
                          data-animation="fadeIn"
                        >
                          <div className="d-flex m-auto w-100">
                            <div className="d-inline-block w-50">
                              <button
                                onClick={this.openHappinessExamples.bind(this)}
                                className="btn btn-warning center-block example_button_radius"
                                style={{
                                  backgroundColor: "#191970",
                                  color: "white",
                                }}
                              >
                                <FormattedHTMLMessage
                                  id="ind.happiness.btn.examples"
                                  defaultMessage="SEE EXAMPLE OF RESULTS"
                                />
                              </button>
                            </div>
                            <div className="d-inline-block w-50">
                              <button
                                onClick={this.openHappiness.bind(this)}
                                className="btn center-block example_button_radius"
                                style={{
                                  backgroundColor: "#1ca9c9",
                                  color: "white",
                                }}
                              >
                                <FormattedHTMLMessage
                                  id="ind.happiness.btn.start"
                                  defaultMessage="Start MyHappiness Test <br/> <div class='small'> Totally FREE (First signed) </div>"
                                />
                              </button>
                            </div>
                            <div className="d-inline-block w-50">
                              <button
                                className="btn btn-warning"
                                style={{
                                  backgroundColor: "#191970",
                                  color: "white",
                                }}
                                onClick={this.buyNowTest.bind(this)}
                              >
                                <FormattedHTMLMessage
                                  id="ind.happiness.btn.first.signed"
                                  defaultMessage="Start Buy Now"
                                />
                                {/* FREE <small>(First Signed)</small> */}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="indi-list">
                        {/* <FormattedHTMLMessage id="ind.happiness.price" defaultMessage="<h3 class=''>Price </h3>"/> */}
                        {/* <div className="row">
                          <div className="col-md-4 col-sm-4 m-auto w100_991">
                            <div className="card text-center mt-4"> */}
                        {/* <div className="card-body"> */}
                        {/* <h4 className="card-title">
                                  <FormattedHTMLMessage id="per.test" defaultMessage="Per Test"/>
                                </h4>
                                <p className="card-text"><i>MyHAPPINESS TEST©</i></p> */}
                        {/* <p className="card-text"><FormattedHTMLMessage id="ind.one.credit" defaultMessage="(or 1 crédit)"/> </p> */}
                        {/* <button className="btn btn-warning" style={{color:"white",backgroundColor:"#808080"}} onClick={this.buyNowTest.bind(this)}>
                                  <FormattedHTMLMessage id="ind.happiness.btn.first.signed" defaultMessage="Start Buy Now"/> */}
                        {/* FREE <small>(First Signed)</small> */}
                        {/* </button> */}
                        {/* </div> */}
                        {/* </div>
                          </div>
                        </div> */}
                       {this.renderIndividualCreditCards()}
                        <h3 className="">&nbsp;</h3>
                        <FormattedHTMLMessage
                          id={userRole === "User" ? "ind.happiness.pice.detail1.user" : "ind.happiness.pice.detail1"}
                          defaultMessage="<ul class='indi-ul'> <li>Buy 1 test credit = <b>€ 20</b>/test</li><li>Buy 2 test credits = <b>€ 13,5</b>/test</li><li>Buy 3 test credits = <b>€ 12</b>/test</li><li>Buy 4 test credits and more = <b>€ 10</b>/test</li></ul>"
                        />
                      </div>
                     
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade pilotModal" id="talent">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-secondary">
                <h4 className="modal-title text-center text-uppercase w-100 medium font-20 text-white">
                  MyTALENT Test
                </h4>
                <button type="button" className="close" data-dismiss="modal">
                  ×
                </button>
              </div>

              <div className="modal-body">
                <div className="">
                  <div className="about" id="services">
                    <div className=" text-justify">
                      <div
                        className="animate animated slideInLeft"
                        data-animation="slideInRight"
                      >
                        <h2 className="about-title text-left">
                          <FormattedHTMLMessage
                            id="ind.talent.popup.title"
                            defaultMessage="MyTALENT Test :<br /> &amp; Identify your natural talents"
                          />
                        </h2>
                      </div>

                      <div className="d-flex m-auto w-100">
                        <div className="d-inline-block w-50">
                          <button
                            onClick={this.openTalentExamples.bind(this)}
                            className="btn btn-warning center-block example_button_radius"
                            style={{
                              backgroundColor: "#191970",
                              color: "white",
                            }}
                          >
                            <FormattedHTMLMessage
                              id="ind.happiness.btn.examples"
                              defaultMessage="SEE EXAMPLE OF RESULTS"
                            />
                          </button>
                        </div>
                        <div className="d-inline-block w-50">
                          <button
                            type="button"
                            className="btn  center-block example_button_radius"
                            onClick={this.openTalent.bind(this)}
                            style={{
                              backgroundColor: "#1ca9c9",
                              color: "white",
                            }}
                          >
                            <FormattedHTMLMessage
                              id="ind.talent.btn.start"
                              defaultMessage="Start MyTALENT Test"
                            />
                          </button>
                        </div>
                        <div className="d-inline-block w-50">
                          <button
                            className="btn btn-warning"
                            style={{
                              backgroundColor: "#191970",
                              color: "white",
                            }}
                            onClick={this.buyNowTest.bind(this)}
                          >
                            <FormattedHTMLMessage
                              id="ind.happiness.btn.first.signed"
                              defaultMessage="Start Buy Now"
                            />
                            {/* FREE <small>(First Signed)</small> */}
                          </button>
                        </div>
                      </div>

                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.happiness.p.duration"
                          defaultMessage="<h3>Duration</h3><ul className='indi-ul'> <li>40 questions – 7 minutes.</li></ul>"
                        />
                      </div>

                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.talent.p.resultlist"
                          defaultMessage="<h3 class=''>Results </h3> <ul class='indi-ul'> <li> Your stong engines and personal work practice. </li><li> What you do with the greatest ease and less fatigue. </li><li>Your communication skills.</li></ul>"
                        />
                        {/* <h3 className="">Results </h3>
                        <ul className="indi-ul">
                          <li>
                            Your stong engines and personal work practice.
                          </li>
                          <li>
                            What you do with the greatest ease and less fatigue.
                          </li>
                          <li>Your communication skills.</li>
                        </ul> */}
                      </div>

                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.talent.p.help"
                          defaultMessage="<h3 class=''>Help </h3> <ul class='indi-ul'> <li>Know your talents and strong points.</li><li>Make a quick professional report.</li><li>Find your way of excellence.</li></ul>"
                        />
                        {/* <h3 className="">Help </h3>
                        <ul className="indi-ul">
                          <li>Know your talents and strong points.</li>
                          <li>Make a quick professional report.</li>
                          <li>Find your way of excellence.</li>
                        </ul> */}
                      </div>

                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.talent.p.research"
                          defaultMessage="<h3 class=''>Scientific-Researches </h3> <p class='modal-text'>MEASURE OF PERSONALITY :</p><p class='pl-3'> Each person approaches the world differently. Some of them by the concrete and operational approach the others by the abstract and functional approach. Well understand how everybody works help to accept differences between individuals. </p><p class='pl-3'> MyTALENT Test highlights range of professions which are you natural for the candidate and what are his/her best talents (Manager/organizer; Inventor/engineer Doer; Communicator). </p><p class='pl-3 reconmendFontSize'> <u>Recommended reading:</u> (The man discovering his soul C.G. Jung - 1963). </p><p class='modal-text'>MEASURE OF MOTIVATIONS:</p><p class='pl-3'> Each person has career anchors or dominant motivational traits that last a lifetime and that can be relied on by the person to build a career </p><p class='pl-3'> MyTALENT Test allows the candidate to prioritize and reveal their motivational preferences (Leadership, service to others, challenge, safety, balance of life, entrepreneurial spirit, autonomy, expertise). </p><p class='pl-3 reconmendFontSize'> <u>Recommended reading:</u> (Career Anchors - E. Schein - 1996 - Last edition 2013). </p><p class='modal-text'> MEASURE OF COMMUNICATION STYLE: </p><p class='pl-3'> Emotions leave a strong mark on the personality (fear, anger, sadness, joy). . Often a taboo topic, feelings are not always well understood. The ability to manage one's feelings and those of others increases communication and persuasion skills. </p><p class='pl-3'> MyTALENT Test allows the candidate to reveal his/her level of communication and what could be still improve in the seven skills of Emotional Quotient (E.Q.) : awareness of feelings, ability to share emotion, ability to live in a group, ability to convey emotion with a group, ability to listen to others, confidence to live with emotion, freedom to follow emotion. </p><p class='pl-3 reconmendFontSize'> <u>Recommended reading:</u> (L’intelligence du coeur – I. Filliozat – 1995. Last edition 2013 - Paris Ed. JC Lattès) </p>"
                        />
                        {/* <h3 className="">Scientific-Researches </h3>
                        <p className="modal-text">MEASURE OF PERSONALITY :</p>
                        <p className="pl-3">
                          Each person approaches the world differently. Some of them by the concrete and operational approach the others by the abstract and functional approach. Well understand how everybody works help to accept differences between individuals.
                        </p>
                        <p className="pl-3">
                          MyTALENT Test highlights range of professions which are you natural for the candidate and what are his/her best talents (Manager/organizer; Inventor/engineer Doer; Communicator).
                        </p>
                        <p className="pl-3 reconmendFontSize">
                          <u>Recommended reading:</u> (The man discovering his soul C.G. Jung - 1963).
                        </p>
                        <p className="modal-text">MEASURE OF MOTIVATIONS:</p>
                        <p className="pl-3">
                          Each person has career anchors or dominant motivational traits that last a lifetime and that can be relied on by the person to build a career
                        </p>
                        <p className="pl-3">
                          MyTALENT Test allows the candidate to prioritize and reveal their motivational preferences (Leadership, service to others, challenge, safety, balance of life, entrepreneurial spirit, autonomy, expertise).
                        </p>
                        <p className="pl-3 reconmendFontSize">
                          <u>Recommended reading:</u> (Career Anchors - E. Schein - 1996 - Last edition 2013).
                        </p>
                        <p className="modal-text">
                          MEASURE OF COMMUNICATION STYLE:
                        </p>
                        <p className="pl-3">
                          Emotions leave a strong mark on the personality (fear, anger, sadness, joy). . Often a taboo topic, feelings are not always well understood. The ability to manage one's feelings and those of others increases communication and persuasion skills.
                        </p>
                        <p className="pl-3">
                          MyTALENT Test allows the candidate to reveal his/her level of communication and what could be still improve in the seven skills of Emotional Quotient (E.Q.) : awareness of feelings, ability to share emotion, ability to live in a group, ability to convey emotion with a group, ability to listen to others, confidence to live with emotion, freedom to follow emotion.
                        </p>
                        <p className="pl-3 reconmendFontSize">
                          <u>Recommended reading:</u> (L’intelligence du coeur – I. Filliozat – 1995. Last edition 2013 - Paris Ed. JC Lattès)
                        </p>                         */}
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.talent.p.start.test"
                          defaultMessage="<h3 class=''>Start Your Test </h3> <div class='about-text'> <p> Before starting ‘MyTALENT test’ you can see an example of results exactly as you will get after taking. Results of your test still totally confidential and we don’t use any named data coming from you for other destination of the test (French Data Authority n°661001)</p></div>"
                        />
                        {/* <h3 className="">Start Your Test </h3>
                        <div className="about-text">
                          <p>
                            Before starting ‘MyTALENT test’ you can see an
                            example of results exactly as you will get after
                            taking. Results of your test still totally
                            confidential and we don’t use any named data coming
                            from you for other destination of the test (French
                            Data Authority n°661001){" "}
                          </p>
                        </div> */}
                        <div
                          className="add-width intro_layer mt-5 d-flex"
                          data-animation="fadeIn"
                        >
                          <div className="d-flex m-auto w-100">
                            <div className="d-inline-block w-50">
                              <button
                                onClick={this.openTalentExamples.bind(this)}
                                className="btn btn-warning center-block example_button_radius"
                                style={{
                                  backgroundColor: "#191970",
                                  color: "white",
                                }}
                              >
                                <FormattedHTMLMessage
                                  id="ind.happiness.btn.examples"
                                  defaultMessage="SEE EXAMPLE OF RESULTS"
                                />
                              </button>
                            </div>
                            <div className="d-inline-block w-50">
                              <button
                                type="button"
                                className="btn  center-block example_button_radius"
                                onClick={this.openTalent.bind(this)}
                                style={{
                                  backgroundColor: "#1ca9c9",
                                  color: "white",
                                }}
                              >
                                <FormattedHTMLMessage
                                  id="ind.talent.btn.start"
                                  defaultMessage="Start MyTALENT Test"
                                />
                              </button>
                            </div>
                            <div className="d-inline-block w-50">
                              <button
                                className="btn btn-warning"
                                style={{
                                  backgroundColor: "#191970",
                                  color: "white",
                                }}
                                onClick={this.buyNowTest.bind(this)}
                              >
                                <FormattedHTMLMessage
                                  id="ind.happiness.btn.first.signed"
                                  defaultMessage="Start Buy Now"
                                />
                                {/* FREE <small>(First Signed)</small> */}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="indi-list">
                        {/* <h3 className=""><FormattedMessage id="price" defaultMessage="Price "/></h3>
                        <div className="row">
                          <div className="col-md-4 col-sm-4 m-auto w100_991">
                            <div className="card text-center mt-4"> */}
                        {/* <div className="card-body">
                                <h4 className="card-title">
                                  <FormattedHTMLMessage id='per.test' defaultMessage='Per Test'/>
                                </h4> */}
                        {/* <p className="card-text"><i>MyTALENT TEST©</i></p> */}
                        {/* <p className="card-text"><FormattedHTMLMessage id="ind.one.credit" defaultMessage="(or 1 crédit)"/> </p> */}
                        {/* <button className="btn btn-warning" style={{color:"white",backgroundColor:"#808080"}} onClick={this.buyNowTest.bind(this)}>
                                  <FormattedMessage id="ind.talent.buy.now" defaultMessage="Start Buy Now"/>
                                </button> */}
                        {/* </div> */}
                        {/* </div>
                          </div>
                        </div> */}
                        {/* <h3 className="">&nbsp;</h3>
                        <FormattedHTMLMessage
                          id={userRole === "User" ? "ind.talent.pice.detail.user" : "ind.talent.pice.detail"}
                          defaultMessage="<ul class='indi-ul'> <li>Buy 1 test credit = <b>€ 20</b>/test</li><li>Buy 2 test credits = <b>€ 13,5</b>/test</li><li>Buy 3 test credits = <b>€ 12</b>/test</li><li>Buy 4 test credits and more = <b>€ 10</b>/test</li></ul>"
                        /> */}
                        {/* <ul className="indi-ul">
                          <li>Buy 1 test credit = <b>€ 20</b>/test</li>
                          <li>Buy 2 test credits = <b>€ 13,5</b>/test</li>
                          <li>Buy 3 test credits = <b>€ 12</b>/test</li>
                          <li>Buy 4 test credits and more = <b>€ 10</b>/test</li>
                        </ul> */}
                         {this.renderIndividualCreditCards()}
                        <h3 className="">&nbsp;</h3>
                        <FormattedHTMLMessage
                          id={userRole === "User" ? "ind.talent.pice.detail1.user" : "ind.talent.pice.detail1"}
                          defaultMessage="<ul class='indi-ul'> <li>Buy 1 test credit = <b>€ 20</b>/test</li><li>Buy 2 test credits = <b>€ 13,5</b>/test</li><li>Buy 3 test credits = <b>€ 12</b>/test</li><li>Buy 4 test credits and more = <b>€ 10</b>/test</li></ul>"
                        />
                      </div>
                     
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade pilotModal" id="target">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-secondary">
                <h4 className="modal-title text-center text-uppercase w-100 medium font-20 text-white">
                  MyTARGET Test
                </h4>
                <button type="button" className="close" data-dismiss="modal">
                  ×
                </button>
              </div>

              <div className="modal-body">
                <div className="">
                  <div className="about" id="services">
                    <div className=" text-justify">
                      <div
                        className=" animate animated slideInLeft"
                        data-animation="slideInLeft"
                      >
                        <h2 className="about-title text-left">
                          <FormattedHTMLMessage
                            id="ind.target.popup.title"
                            defaultMessage="MyTARGET Test : <br />&amp; Identify your best place to work"
                          />
                        </h2>
                      </div>
                      <div className="d-flex m-auto w-100">
                        <div className="d-inline-block w-50">
                          <button
                            onClick={this.openTargetExamples.bind(this)}
                            className="btn btn-warning center-block example_button_radius"
                            style={{
                              backgroundColor: "#191970",
                              color: "white",
                            }}
                          >
                            <FormattedHTMLMessage
                              id="ind.happiness.btn.examples"
                              defaultMessage="SEE EXAMPLE OF RESULTS"
                            />
                          </button>
                        </div>
                        <div className="d-inline-block w-50">
                          <button
                            type="button"
                            className="btn  center-block example_button_radius"
                            onClick={this.openTarget.bind(this)}
                            style={{
                              backgroundColor: "#1ca9c9",
                              color: "white",
                            }}
                          >
                            <FormattedHTMLMessage
                              id="ind.target.btn.start"
                              defaultMessage="Start MyTARGET Test"
                            />
                          </button>
                        </div>
                        <div className="d-inline-block w-50">
                          <button
                            className="btn btn-warning"
                            style={{
                              backgroundColor: "#191970",
                              color: "white",
                            }}
                            onClick={this.buyNowTest.bind(this)}
                          >
                            <FormattedHTMLMessage
                              id="ind.happiness.btn.first.signed"
                              defaultMessage="Start Buy Now"
                            />
                            {/* FREE <small>(First Signed)</small> */}
                          </button>
                        </div>
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.target.p.duration"
                          defaultMessage="<h3>Duration</h3><ul className='indi-ul'> <li>23 questions - 6 minutes.</li></ul>"
                        />
                      </div>

                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.target.p.resultlist"
                          defaultMessage="<h3>Duration</h3><ul className='indi-ul'> <li>40 questions – 7 minutes.</li></ul>"
                        />
                        {/* <h3 className="">Results </h3>
                        <ul className="indi-ul">
                          <li>
                            Your best place to work (work culture, context,
                            management).
                          </li>
                          <li>
                            What you need as work atmosphere and enviroment
                          </li>
                          <li>Your communication skills.</li>
                        </ul> */}
                      </div>

                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.target.p.help"
                          defaultMessage="<h3 class=''>Help </h3> <ul class='indi-ul'> <li>Better know you want</li><li> Identify your priority target for looking at a job </li><li>Find your way of excellence. </li></ul>"
                        />
                        {/* <h3 className="">Help </h3>
                        <ul className="indi-ul">
                          <li>Better know you want</li>
                          <li>
                            Identify your priority target for looking at a job
                          </li>
                          <li>Find your way of excellence. </li>
                        </ul> */}
                      </div>

                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.target.p.research"
                          defaultMessage="<h3 class=''>Scientific-Researches </h3> <p class='modal-text'> MEASURE OF WORK CONTEXTS :{' '}</p><p class='pl-3'> Each company has a body of rules that makes it belong to different social worlds. </p><p class='pl-3'> MyTARGET Test allows the candidate to check which socio-professional world he feels closest to and where he can best develop (regulatory world, community, professional public service, professional, mobility, entrepreneurial). </p><p class='pl-3 reconmendFontSize'> <u>Recommended reading:</u> I. Francfort, F. Osty, M. Uhalde (Les mondes sociaux de l’entreprise – Paris 1995 – Ed. Desclée de Brouwer – Last Edition 2007) </p><p class='modal-text'>MEASURE OF WORK CULTURE : </p><p class='pl-3'> Each company has a mix of culture composed by history, actions, relationships, thinking, know-how and people. </p><p class='pl-3'> MyTARGET Test allows the candidate to check what is most important for him/her and suit best with companies. </p><p class='pl-3 reconmendFontSize'> <u>Recommended reading:</u> C. Hampden-Turner (La culture d’entreprise : des cercles vicieux aux cercles vertueux – Paris 1992 – Ed. du Seuil) </p><p class='modal-text'> MEASURE OF WORK MANAGEMENT : </p><p class='pl-3'> Management approach still very different in Institution, Corporation, Small Business or independent. Each people has his/her own references and habits. </p><p class='pl-3'> MyTARGET Test allows the candidate to sort witch management approach suit best to him or her. </p><p class='pl-3 reconmendFontSize'> <u>Recommended reading:</u> C. Handy (L’Olympe des Managers – 1992 – Paris - Ed. du Seuil) </p><p class='modal-text'> MEASURE OF WORK ATMOSPHERE : </p><p class='pl-3'> People are more productive if they find the right atmosphere according to their personality. </p><p class='pl-3'> MyTARGET Test allows the candidate to sort with witch people and atmosphere suit best to him or her. </p><p class='pl-3 reconmendFontSize'> <u>Recommended reading:</u> P. Pitcher (Artistes, Artisans et Technocrates –Paris - 1996– Ed. Village Mondial – Last Edition 2000). </p>"
                        />
                        {/* <h3 className="">Scientific-Researches </h3>
                        <p className="modal-text">
                          MEASURE OF WORK CONTEXTS :{" "}
                        </p>
                        <p className="pl-3">
                          Each company has a body of rules that makes it belong to different social worlds.
                        </p>
                        <p className="pl-3">
                          MyTARGET Test allows the candidate to check which socio-professional world he feels closest to and where he can best develop (regulatory world, community, professional public service, professional, mobility, entrepreneurial).
                        </p>
                        <p className="pl-3 reconmendFontSize">
                          <u>Recommended reading:</u> I. Francfort, F. Osty, M. Uhalde (Les mondes sociaux de l’entreprise – Paris 1995 – Ed. Desclée de Brouwer – Last Edition 2007)
                        </p>
                        <p className="modal-text">MEASURE OF WORK CULTURE : </p>
                        <p className="pl-3">
                          Each company has a mix of culture composed by history, actions, relationships, thinking, know-how and people.
                        </p>
                        <p className="pl-3">
                          MyTARGET Test allows the candidate to check what is most important for him/her and suit best with companies.
                        </p>
                        <p className="pl-3 reconmendFontSize">
                          <u>Recommended reading:</u> C. Hampden-Turner (La culture d’entreprise : des cercles vicieux aux cercles vertueux – Paris 1992 – Ed. du Seuil)
                        </p>

                        <p className="modal-text">
                          MEASURE OF WORK MANAGEMENT :
                        </p>
                        <p className="pl-3">
                          Management approach still very different in Institution, Corporation, Small Business or independent. Each people has his/her own references and habits.
                        </p>
                        <p className="pl-3">
                          MyTARGET Test allows the candidate to sort witch management approach suit best to him or her.
                        </p>
                        <p className="pl-3 reconmendFontSize">
                          <u>Recommended reading:</u> C. Handy (L’Olympe des Managers – 1992 – Paris - Ed. du Seuil)
                        </p>

                        <p className="modal-text">
                          MEASURE OF WORK ATMOSPHERE :
                        </p>
                        <p className="pl-3">
                          People are more productive if they find the right atmosphere according to their personality.
                        </p>
                        <p className="pl-3">
                          MyTARGET Test allows the candidate to sort with witch people and atmosphere suit best to him or her.
                        </p>
                        <p className="pl-3 reconmendFontSize">
                          <u>Recommended reading:</u> P. Pitcher (Artistes, Artisans et Technocrates –Paris - 1996– Ed. Village Mondial – Last Edition 2000).
                        </p>                                                 */}
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.target.p.start.test"
                          defaultMessage="<h3 class=''>Start Your Test </h3> <div class='about-text'> <p> Before starting MyTARGET test’ you can see an example of results exactly as you will get after taking. Results of your test still totally confidential and we don’t use any named data coming from you for other destination of the test (French Data Authority n°661001)</p></div>"
                        />
                        {/* <h3 className="">Start Your Test </h3>
                        <div className="about-text">
                          <p>
                            Before starting MyTARGET test’ you can see an
                            example of results exactly as you will get after
                            taking. Results of your test still totally
                            confidential and we don’t use any named data coming
                            from you for other destination of the test (French
                            Data Authority n°661001){" "}
                          </p>
                        </div> */}

                        <div
                          className="add-width intro_layer mt-5 d-flex"
                          data-animation="fadeIn"
                        >
                          <div className="d-flex m-auto w-100">
                            <div className="d-inline-block w-50">
                              <button
                                onClick={this.openTargetExamples.bind(this)}
                                className="btn btn-warning center-block example_button_radius"
                                style={{
                                  backgroundColor: "#191970",
                                  color: "white",
                                }}
                              >
                                <FormattedHTMLMessage
                                  id="ind.happiness.btn.examples"
                                  defaultMessage="SEE EXAMPLE OF RESULTS"
                                />
                              </button>
                            </div>
                            <div className="d-inline-block w-50">
                              <button
                                type="button"
                                className="btn  center-block example_button_radius"
                                onClick={this.openTarget.bind(this)}
                                style={{
                                  backgroundColor: "#1ca9c9",
                                  color: "white",
                                }}
                              >
                                <FormattedHTMLMessage
                                  id="ind.target.btn.start"
                                  defaultMessage="Start MyTARGET Test"
                                />
                              </button>
                            </div>
                            <div className="d-inline-block w-50">
                              <button
                                className="btn btn-warning"
                                style={{
                                  backgroundColor: "#191970",
                                  color: "white",
                                }}
                                onClick={this.buyNowTest.bind(this)}
                              >
                                <FormattedHTMLMessage
                                  id="ind.happiness.btn.first.signed"
                                  defaultMessage="Start Buy Now"
                                />
                                {/* FREE <small>(First Signed)</small> */}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="indi-list">
                        {/* <h3 className=""><FormattedMessage id="price" defaultMessage="Price "/></h3>
                        <div className="row">
                          <div className="col-md-4 col-sm-4 m-auto w100_991">
                            <div className="card text-center mt-4"> */}
                        {/* <div className="card-body">
                                <h4 className="card-title">
                                  <FormattedHTMLMessage id='per.test' defaultMessage='Per Test'/>
                                </h4>
                                <p className="card-text"><i>MyTARGET TEST©</i></p> */}
                        {/* <p className="card-text"><FormattedHTMLMessage id="ind.one.credit" defaultMessage="(or 1 crédit)"/> </p> */}
                        {/* <button className="btn btn-warning" onClick={this.buyNowTest.bind(this)}>
                                  <FormattedHTMLMessage id="ind.target.buy.now" defaultMessage="Buy Now"/>
                                </button> */}
                        {/* <button className="btn btn-warning" style={{color:"white",backgroundColor:"#808080"}} onClick={this.buyNowTest.bind(this)}>
                                  <FormattedMessage id="ind.talent.buy.now" defaultMessage="Start Buy Now"/>
                                </button> */}
                        {/* </div> */}
                        {/* </div>
                          </div>
                        </div> */}
                        {/* <h3 className="">&nbsp;</h3>
                        <FormattedHTMLMessage id="ind.target.pice.detail" defaultMessage="<ul class='indi-ul'> <li> Buy 1 test credit = <b>€ 20</b> </li><li> Buy 2 test credits = <b>€ 27</b> </li><li> Buy 3 test credits = <b>€ 36</b> </li><li> Buy 4 test credits and more = <b>€ 10</b> each </li></ul>"/> */}
                        {/* <ul className="indi-ul">
                          <li>
                            Buy 1 test credit = <b>€ 20</b>
                          </li>
                          <li>
                            Buy 2 test credits = <b>€ 27</b>
                          </li>
                          <li>
                            Buy 3 test credits = <b>€ 36</b>
                          </li>
                          <li>
                            Buy 4 test credits and more = <b>€ 10</b> each
                          </li>
                        </ul> */}
                        {/* <h3 className="">&nbsp;</h3>
                        <FormattedHTMLMessage
                          id={userRole === "User" ? "ind.happiness.pice.detail.user" : "ind.happiness.pice.detail"}
                          defaultMessage="<ul class='indi-ul'> <li>Buy 1 test credit = <b>€ 20</b>/test</li><li>Buy 2 test credits = <b>€ 13,5</b>/test</li><li>Buy 3 test credits = <b>€ 12</b>/test</li><li>Buy 4 test credits and more = <b>€ 10</b>/test</li></ul>"
                        /> */}
                        {this.renderIndividualCreditCards()}
                        <h3 className="">&nbsp;</h3>
                        <FormattedHTMLMessage
                          id={userRole === "User" ? "ind.happiness.pice.detail1.user" : "ind.happiness.pice.detail1"}
                          defaultMessage="<ul class='indi-ul'> <li>Buy 1 test credit = <b>€ 20</b>/test</li><li>Buy 2 test credits = <b>€ 13,5</b>/test</li><li>Buy 3 test credits = <b>€ 12</b>/test</li><li>Buy 4 test credits and more = <b>€ 10</b>/test</li></ul>"
                        />
                      </div>
                     
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade pilotModal" id="sale">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-secondary">
                <h4 className="modal-title text-center text-uppercase w-100 medium font-20 text-white">
                  MySALES Test
                </h4>
                <button type="button" className="close" data-dismiss="modal">
                  ×
                </button>
              </div>

              <div className="modal-body">
                <div className="">
                  <div className="about" id="services">
                    <div className=" text-justify">
                      <div
                        className=" animate animated slideInLeft"
                        data-animation="slideInLeft"
                      >
                        <h2 className="about-title text-left">
                          <FormattedHTMLMessage
                            id="ind.sale.popup.title"
                            defaultMessage="MySALES Test :<br /> &amp; Maesure your sale potential"
                          />
                        </h2>
                      </div>
                      <div className="d-flex m-auto w-100">
                        <div className="d-inline-block w-50">
                          <button
                            onClick={this.openSaleExamples.bind(this)}
                            className="btn btn-warning center-block example_button_radius"
                            style={{
                              backgroundColor: "#191970",
                              color: "white",
                            }}
                          >
                            <FormattedHTMLMessage
                              id="ind.happiness.btn.examples"
                              defaultMessage="SEE EXAMPLE OF RESULTS"
                            />
                          </button>
                        </div>
                        <div className="d-inline-block w-50">
                          <button
                            type="button"
                            className="btn center-block example_button_radius"
                            onClick={this.openSale.bind(this)}
                            style={{
                              backgroundColor: "#1ca9c9",
                              color: "white",
                            }}
                          >
                            <FormattedHTMLMessage
                              id="ind.sale.btn.start"
                              defaultMessage="Start MySALES Test"
                            />
                          </button>
                        </div>
                        <div className="d-inline-block w-50">
                          <button
                            className="btn btn-warning"
                            style={{
                              backgroundColor: "#191970",
                              color: "white",
                            }}
                            onClick={this.buyNowTest.bind(this)}
                          >
                            <FormattedHTMLMessage
                              id="ind.happiness.btn.first.signed"
                              defaultMessage="Start Buy Now"
                            />
                            {/* FREE <small>(First Signed)</small> */}
                          </button>
                        </div>
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.sale.p.duration"
                          defaultMessage="<h3>Duration</h3><ul class='indi-ul'> <li>40 questions – 7 minutes.</li></ul>"
                        />
                        {/* <h3>Duration </h3>
                        <ul className="indi-ul">
                          <li>40 questions – 7 minutes. </li>
                        </ul> */}
                      </div>

                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.sale.p.resultlist"
                          defaultMessage="<h3 class=''>Results </h3> <ul class='indi-ul'> <li> Your potential of sale compare to the average. </li><li> Your potentiel of sale on eight key factors of success of sale </li><li>What you can still improved to sale more.</li></ul>"
                        />
                        {/* <h3 className="">Results </h3>
                        <ul className="indi-ul">
                          <li>
                            Your potential of sale compare to the average.
                          </li>
                          <li>
                            Your potentiel of sale on eight key factors of
                            success of sale
                          </li>
                          <li>What you can still improved to sale more.</li>
                        </ul> */}
                      </div>

                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.sale.p.help"
                          defaultMessage="<h3 class=''>Help </h3> <ul class='indi-ul'> <li>Prepare a professional interview. </li><li> Identify your strong and your weak points to improve. </li><li>Decide to join a sale job.</li></ul>"
                        />
                        {/* <h3 className="">Help </h3>
                        <ul className="indi-ul">
                          <li>Prepare a professional interview. </li>
                          <li>
                            Identify your strong and your weak points to
                            improve.
                          </li>
                          <li>Decide to join a sale job.</li>
                        </ul> */}
                      </div>

                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.sale.p.research"
                          defaultMessage="<h3 class=''>Scientific-Researches </h3> <p>MEASURE OF SALE POTENTIAL:</p><p> Each people had a potential to sell even if it’s not his/her job or training. In any case it’s very important to know his / her potential and own resources first to sell him of herself. </p><p> MySALES Test allows the candidate to assess himself (herself) on eight keys factors of success to sell (Openness, Listening Skills, Adaptability, Know How, Negotiation Skills, Decision Making, Self-Control, Drive). </p><p class='pl-3 reconmendFontSize'> <u>Recommended reading:</u> (Les techniques de la vente – E. Moulinier - Paris 2007 – Ed. Eyrolles) recommend too by D.C.F Association (Dirigeant Commerciaux de France). </p>"
                        />
                        {/* <h3 className="">Scientific-Researches </h3>
                        <p>MEASURE OF SALE POTENTIAL:</p>
                        <p>
                          Each people had a potential to sell even if it’s not his/her job or training. In any case it’s very important to know his / her potential and own resources first to sell him of herself.
                        </p>
                        <p>
                          MySALE Test allows the candidate to assess himself (herself) on eight keys factors of success to sell (Openness, Listening Skills, Adaptability, Know How, Negotiation Skills, Decision Making, Self-Control, Drive).
                        </p>
                        <p className="pl-3 reconmendFontSize">
                          <u>Recommended reading:</u> (Les techniques de la vente – E. Moulinier - Paris 2007 – Ed. Eyrolles) recommend too by D.C.F Association (Dirigeant Commerciaux de France).
                        </p>                                                 */}
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.sale.p.start.test"
                          defaultMessage="<h3 class=''>Start Your Test </h3> <div class='about-text'> <p> Before starting ‘MySALE Test’ you can see an example of results exactly as you will get after taking. Results of your test still totally confidential and we don’t use any named data coming from you for other destination of the test (French Data Authority n°661001) </p>"
                        />
                        {/* <h3 className="">Start Your Test </h3>
                        <div className="about-text">
                          <p>
                            Before starting ‘MySALE Test’ you can see an
                            example of results exactly as you will get after
                            taking. Results of your test still totally
                            confidential and we don’t use any named data coming
                            from you for other destination of the test (French
                            Data Authority n°661001)
                          </p>
                        </div> */}

                        <div
                          className="add-width intro_layer mt-5 d-flex"
                          data-animation="fadeIn"
                        >
                          <div className="d-flex m-auto w-100">
                            <div className="d-inline-block w-50">
                              <button
                                onClick={this.openSaleExamples.bind(this)}
                                className="btn btn-warning center-block example_button_radius"
                                style={{
                                  backgroundColor: "#191970",
                                  color: "white",
                                }}
                              >
                                <FormattedHTMLMessage
                                  id="ind.happiness.btn.examples"
                                  defaultMessage="SEE EXAMPLE OF RESULTS"
                                />
                              </button>
                            </div>
                            <div className="d-inline-block w-50">
                              <button
                                type="button"
                                className="btn center-block example_button_radius"
                                onClick={this.openSale.bind(this)}
                                style={{
                                  backgroundColor: "#1ca9c9",
                                  color: "white",
                                }}
                              >
                                <FormattedHTMLMessage
                                  id="ind.sale.btn.start"
                                  defaultMessage="Start MySALES Test"
                                />
                              </button>
                            </div>
                            <div className="d-inline-block w-50">
                              <button
                                className="btn btn-warning"
                                style={{
                                  backgroundColor: "#191970",
                                  color: "white",
                                }}
                                onClick={this.buyNowTest.bind(this)}
                              >
                                <FormattedHTMLMessage
                                  id="ind.happiness.btn.first.signed"
                                  defaultMessage="Start Buy Now"
                                />
                                {/* FREE <small>(First Signed)</small> */}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="indi-list">
                        {/* <FormattedHTMLMessage id="ind.sale.price" defaultMessage="<h3 class=''>Price </h3>"/>
                        <div className="row">
                          <div className="col-md-4 col-sm-4 m-auto w100_991">
                            <div className="card text-center mt-4"> */}
                        {/* <div className="card-body">
                                <h4 className="card-title">
                                  <FormattedHTMLMessage id="per.test" defaultMessage="Per Test"/>
                                </h4>
                                <p className="card-text"><i>MySALES TEST©</i></p> */}
                        {/* <p className="card-text"><FormattedHTMLMessage id="ind.one.credit" defaultMessage="(or 1 crédit)"/> </p> */}
                        {/* <button className="btn btn-warning" onClick={this.buyNowTest.bind(this)}>
                                <FormattedHTMLMessage id="ind.sale.buy.now" defaultMessage="Buy Now"/>
                                </button> */}
                        {/* <button className="btn btn-warning" style={{color:"white",backgroundColor:"#808080"}} onClick={this.buyNowTest.bind(this)}>
                                  <FormattedMessage id="ind.talent.buy.now" defaultMessage="Start Buy Now"/>
                                </button> */}
                        {/* </div> */}
                        {/* </div>
                          </div>
                        </div> */}
                        {/* <h3 className="">&nbsp;</h3>
                        <FormattedHTMLMessage id="ind.sale.pice.detail" defaultMessage="<ul class='indi-ul'> <li> Buy 1 test credit = <b>€ 20</b> </li><li> Buy 2 test credits = <b>€ 27</b> </li><li> Buy 3 test credits = <b>€ 36</b> </li><li> Buy 4 test credits or more <b>€ 10</b> each </li></ul>"/>
                      </div> */}
                        {/* <h3 className="">&nbsp;</h3>
                        <FormattedHTMLMessage
                          id={userRole === "User" ? "ind.happiness.pice.detail.user" : "ind.happiness.pice.detail"}
                          defaultMessage="<ul class='indi-ul'> <li>Buy 1 test credit = <b>€ 20</b>/test</li><li>Buy 2 test credits = <b>€ 13,5</b>/test</li><li>Buy 3 test credits = <b>€ 12</b>/test</li><li>Buy 4 test credits and more = <b>€ 10</b>/test</li></ul>"
                        /> */}
                       {this.renderIndividualCreditCards()}
                        <h3 className="">&nbsp;</h3>
                        <FormattedHTMLMessage
                          id={userRole === "User" ? "ind.happiness.pice.detail1.user" : "ind.happiness.pice.detail1"}
                          defaultMessage="<ul class='indi-ul'> <li>Buy 1 test credit = <b>€ 20</b>/test</li><li>Buy 2 test credits = <b>€ 13,5</b>/test</li><li>Buy 3 test credits = <b>€ 12</b>/test</li><li>Buy 4 test credits and more = <b>€ 10</b>/test</li></ul>"
                        />
                      </div>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade pilotModal" id="enterprise">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-secondary">
                <h4 className="modal-title text-center text-uppercase w-100 medium font-20 text-white">
                  MyCREATION Test
                </h4>
                <button type="button" className="close" data-dismiss="modal">
                  ×
                </button>
              </div>

              <div className="modal-body">
                <div className="">
                  <div className="about" id="services">
                    <div className=" text-justify">
                      <div
                        className=" animate animated slideInLeft"
                        data-animation="slideInLeft"
                      >
                        <h2 className="about-title text-left">
                          <FormattedHTMLMessage
                            id="ind.creation.popup.title"
                            defaultMessage="MyCREATION Test : <br />Maesure your business creation potential"
                          />
                        </h2>
                      </div>
                      <div className="d-flex m-auto w-100">
                        <div className="d-inline-block w-50">
                          <button
                            onClick={this.openCreationExamples.bind(this)}
                            className="btn btn-warning center-block example_button_radius"
                            style={{
                              backgroundColor: "#191970",
                              color: "white",
                            }}
                          >
                            <FormattedHTMLMessage
                              id="ind.happiness.btn.examples"
                              defaultMessage="SEE EXAMPLE OF RESULTS"
                            />
                          </button>
                        </div>
                        <div className="d-inline-block w-50">
                          <button
                            type="button"
                            className="btn  center-block example_button_radius"
                            onClick={this.openCreation.bind(this)}
                            style={{
                              backgroundColor: "#1ca9c9",
                              color: "white",
                            }}
                          >
                            <FormattedHTMLMessage
                              id="ind.creation.btn.start"
                              defaultMessage="Start MyCREATION Test"
                            />
                          </button>
                        </div>
                        <div className="d-inline-block w-50">
                          <button
                            className="btn btn-warning"
                            style={{
                              backgroundColor: "#191970",
                              color: "white",
                            }}
                            onClick={this.buyNowTest.bind(this)}
                          >
                            <FormattedHTMLMessage
                              id="ind.happiness.btn.first.signed"
                              defaultMessage="Start Buy Now"
                            />
                            {/* FREE <small>(First Signed)</small> */}
                          </button>
                        </div>
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.creation.p.duration"
                          defaultMessage="<h3>Duration </h3><ul class='indi-ul'><li>40 questions – 7 minutes. </li></ul>"
                        />
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.creation.p.resultlist"
                          defaultMessage="<h3 class=''>Results </h3> <ul class='indi-ul'> <li> Your potential of business creation compare to the average. </li><li> Your potentiel of business creation on eight key factors of success </li><li> What you can still improved to be ready to create. </li></ul>"
                        />
                        {/* <h3 className="">Results </h3>
                        <ul className="indi-ul">
                          <li>
                            Your potential of business creation compare to the
                            average.
                          </li>
                          <li>
                            Your potentiel of business creation on eight key
                            factors of success
                          </li>
                          <li>
                            What you can still improved to be ready to create.
                          </li>
                        </ul> */}
                      </div>

                      {/* <div className="indi-list">
                        <h3 className="">Help </h3>
                        <ul className="indi-ul">
                          <li>
                            Know if you have skills to create your own business
                          </li>
                          <li>
                            Know if you are ready to create your own business
                          </li>
                          <li>Identify your weak points to improve. </li>
                        </ul>
                      </div> */}
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.creation.p.research"
                          defaultMessage="<h3 class=''>Scientific-Researches </h3> <p class='modal-text'> POTENTIAL OF CREATIVITY: </p><p class='pl-3'> Each people has the potential to create even if you don’t plan to start up your own company or work for yourself. In each case it’s very important to know your own potential of creativity and how to take more responsibility in your work.</p><p class='pl-3'> <b class='title_italic'>MyCREATION TEST©</b> allows the candidate to assess himself (herself) based on eight key factors to success to create (Initiative/Creativity, Ambition/Work capability, Ability to manage people, Ability to sell, Organization skills, Business knowledge, Ability to run a business, Personal situation).. </p><p class='pl-3 reconmendFontSize'> <u>Recommended reading:</u> PAPIN Robert. La création d’entreprise. Paris. Éd. Dunod. 2015. 16ème édition, awarded by HEC (Hautes Études Commerciales de Paris) – High Business School of Management in Paris).</p>"
                        />
                        {/* <h3 className="">Scientific-Researches </h3>
                        <p className="modal-text">
                          MEASURE OF CREATION POTENTIAL:
                        </p>
                        <p className="pl-3">
                          Each people have a potential to create even you don’t plan to create your own company or work for yourself. In any case it’s very important to know your own potential of creation to take more responsibility in your job.
                        </p>
                        <p className="pl-3">
                          MyCREATION Test allows the candidate to assess himself (herself) on eight keys factors of success to create (Initiative/Creativity, Ambition/Work capability, Ability to manage people, Ability to sell, Organization skills, Business knowledge, Ability to run a business, Personal situation).
                        </p>
                        <p className="pl-3 reconmendFontSize">
                          <u>Recommended reading:</u> (La création d’entreprise – R. Papin - Paris 2015 – 16ème édition Ed. Dunod) recommended also by H.E.C (Hautes Etudes Commerciales de Paris – High Business School of Management in Paris).
                        </p> */}
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.creation.p.start.test"
                          defaultMessage="<h3 class=''>Start Your Test </h3> <div class='about-text'> <p> Before starting ‘MyCREATION Test’ you can see an example of results exactly as you will get after taking. Your test still totally confidential and we don’t use any named data coming from you for other destination of the test (French Data Authority n°661001){' '}</p>"
                        />
                        {/* <h3 className="">Start Your Test </h3>
                        <div className="about-text">
                          <p>
                            Before starting ‘MyCREATION Test’ you can see an
                            example of results exactly as you will get after
                            taking. Your test still totally confidential and we
                            don’t use any named data coming from you for other
                            destination of the test (French Data Authority
                            n°661001){" "}
                          </p>
                        </div> */}

                        <div
                          className="add-width intro_layer mt-5 d-flex"
                          data-animation="fadeIn"
                        >
                          <div className="d-flex m-auto w-100">
                            <div className="d-inline-block w-50">
                              <button
                                onClick={this.openCreationExamples.bind(this)}
                                className="btn btn-warning center-block example_button_radius"
                                style={{
                                  backgroundColor: "#191970",
                                  color: "white",
                                }}
                              >
                                <FormattedHTMLMessage
                                  id="ind.happiness.btn.examples"
                                  defaultMessage="SEE EXAMPLE OF RESULTS"
                                />
                              </button>
                            </div>
                            <div className="d-inline-block w-50">
                              <button
                                type="button"
                                className="btn  center-block example_button_radius"
                                onClick={this.openCreation.bind(this)}
                                style={{
                                  backgroundColor: "#1ca9c9",
                                  color: "white",
                                }}
                              >
                                <FormattedHTMLMessage
                                  id="ind.creation.btn.start"
                                  defaultMessage="Start MyCREATION Test"
                                />
                              </button>
                            </div>
                            <div className="d-inline-block w-50">
                              <button
                                className="btn btn-warning"
                                style={{
                                  backgroundColor: "#191970",
                                  color: "white",
                                }}
                                onClick={this.buyNowTest.bind(this)}
                              >
                                <FormattedHTMLMessage
                                  id="ind.happiness.btn.first.signed"
                                  defaultMessage="Start Buy Now"
                                />
                                {/* FREE <small>(First Signed)</small> */}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="indi-list">
                        {/* <h3 className=""><FormattedMessage id="price" defaultMessage="Price "/></h3>
                        <div className="row">
                          <div className="col-md-4 col-sm-4 m-auto w100_991">
                            <div className="card text-center mt-4"> */}
                        {/* <div className="card-body">
                                <h4 className="card-title">
                                  <FormattedHTMLMessage id="per.test" defaultMessage="Per Test"/>
                                </h4>
                                <p className="card-text"><i>MyCREATION TEST©</i></p> */}
                        {/* <p className="card-text"><FormattedHTMLMessage id="ind.one.credit" defaultMessage="(or 1 crédit)"/> </p> */}
                        {/* <button className="btn btn-warning" onClick={this.buyNowTest.bind(this)}>
                                <FormattedHTMLMessage id="ind.creation.buy.now" defaultMessage="Buy Now"/>
                                </button> */}
                        {/* <button className="btn btn-warning" style={{color:"white",backgroundColor:"#808080"}} onClick={this.buyNowTest.bind(this)}>
                                  <FormattedMessage id="ind.talent.buy.now" defaultMessage="Start Buy Now"/>
                                </button> */}
                        {/* </div> */}
                        {/* </div>
                          </div>
                        </div> */}
                        {/* <h3 className="">&nbsp;</h3>
                        <FormattedHTMLMessage id="ind.creation.pice.detail" defaultMessage="<ul class='indi-ul'> <li> Buy 1 test credit = <b>€ 20</b> </li><li> Buy 2 test credits = <b>€ 27</b> </li><li> Buy 3 test credits = <b>€ 36</b> </li><li> Buy 4 test credits or more <b>€ 10</b> each </li></ul>"/>
                      </div> */}
                        {/* <h3 className="">&nbsp;</h3>
                        <FormattedHTMLMessage
                          id={userRole === "User" ? "ind.happiness.pice.detail.user" : "ind.happiness.pice.detail"}
                          defaultMessage="<ul class='indi-ul'> <li>Buy 1 test credit = <b>€ 20</b>/test</li><li>Buy 2 test credits = <b>€ 13,5</b>/test</li><li>Buy 3 test credits = <b>€ 12</b>/test</li><li>Buy 4 test credits and more = <b>€ 10</b>/test</li></ul>"
                        /> */}
                        {this.renderIndividualCreditCards()}
                        <h3 className="">&nbsp;</h3>
                        <FormattedHTMLMessage
                          id={userRole === "User" ? "ind.happiness.pice.detail1.user" : "ind.happiness.pice.detail1"}
                          defaultMessage="<ul class='indi-ul'> <li>Buy 1 test credit = <b>€ 20</b>/test</li><li>Buy 2 test credits = <b>€ 13,5</b>/test</li><li>Buy 3 test credits = <b>€ 12</b>/test</li><li>Buy 4 test credits and more = <b>€ 10</b>/test</li></ul>"
                        />
                      </div>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade pilotModal" id="FRANCHISE">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-secondary">
                <h4 className="modal-title text-center text-uppercase w-100 medium text-white">
                  MyFRANCHISE Test
                </h4>
                <button type="button" className="close" data-dismiss="modal">
                  ×
                </button>
              </div>

              <div className="modal-body">
                <div className="">
                  <div className="about" id="services">
                    <div className=" text-justify">
                      <div
                        className=" animate animated slideInLeft"
                        data-animation="slideInLeft"
                      >
                        <h2 className="about-title text-left">
                          <FormattedHTMLMessage
                            id="ind.franchise.popup.title"
                            defaultMessage="<i>MyFRANCHISE TEST©</i> : <br />Measure your ability to be successful with Franchise"
                          />
                        </h2>
                      </div>
                      <div className="d-flex m-auto w-100">
                        <div className="d-inline-block w-50">
                          <button
                            onClick={this.openFranchiseExamples.bind(this)}
                            className="btn btn-warning center-block example_button_radius"
                            style={{
                              backgroundColor: "#191970",
                              color: "white",
                            }}
                          >
                            <FormattedHTMLMessage
                              id="ind.happiness.btn.examples"
                              defaultMessage="SEE EXAMPLE OF RESULTS"
                            />
                          </button>
                        </div>
                        <div className="d-inline-block w-50">
                          <button
                            type="button"
                            className="btn  center-block example_button_radius"
                            onClick={this.openFranchise.bind(this)}
                            style={{
                              backgroundColor: "#1ca9c9",
                              color: "white",
                            }}
                          >
                            <FormattedHTMLMessage
                              id="ind.franchise.btn.start"
                              defaultMessage="Start MyFRANCHISE Test"
                            />
                          </button>
                        </div>
                        <div className="d-inline-block w-50">
                          <button
                            className="btn btn-warning"
                            style={{
                              backgroundColor: "#191970",
                              color: "white",
                            }}
                            onClick={this.buyNowTest.bind(this)}
                          >
                            <FormattedHTMLMessage
                              id="ind.happiness.btn.first.signed"
                              defaultMessage="Start Buy Now"
                            />
                            {/* FREE <small>(First Signed)</small> */}
                          </button>
                        </div>
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.franchise.p.duration"
                          defaultMessage="<h3>Duration </h3><ul class='indi-ul'><li>40 questions – 7 minutes. </li></ul>"
                        />
                      </div>

                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.franchise.p.resultlist"
                          defaultMessage="<h3 class=''>Results </h3> <ul class='indi-ul'> <li> Your potential of success with a franchise compare to the average.{' '}</li><li> Your adequation with skills and work culture of list of franchising </li><li> What you can still improved to be ready to create in franchise. </li></ul>"
                        />
                        {/* <h3 className="">Results </h3>
                        <ul className="indi-ul">
                          <li>
                            Your potential of success with a franchise compare to
                            the average.{" "}
                          </li>
                          <li>
                            Your adequation with skills and work culture of list
                            of franchising
                          </li>
                          <li>
                            What you can still improved to be ready to create in
                            franchise.
                          </li>
                        </ul> */}
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.franchise.p.research"
                          defaultMessage="<h3 class=''>Scientific-Researches </h3> <p class='modal-text'> MEASURE OF FRANCHISE POTENTIAL : </p><p class='pl-3'> Each people had a potential to create but not alone necessary. Franchise is between having a job and create his/her business. It’s a financial partnership with a wellknown company witch duplicate a successfull concept. </p><p class='pl-3'> MyFRANCHISE Test allows the candidate to assess himself (herself) on eight keys factors of success to be successful in Franchise that is a mix of ability to sell and create (Openness, Adaptability, Decision Making, Ability to manage people, Ability to sell, Organization skills, Ability to run a business, Personal situation). </p><p class='pl-3 reconmendFontSize'> <u>Recommended reading:</u> (Devenir franchisé ou lancer une franchise – C. Zimmer - Paris 2011 – 3ème édition Ed. Vuibert) recommended by F.F.F (Fédération Française de la Franchise de Paris). </p>"
                        />
                        {/* <h3 className="">Scientific-Researches </h3>
                        <p className="modal-text">
                          MEASURE OF FRANCHISE POTENTIAL :
                        </p>
                        <p className="pl-3">
                          Each people had a potential to create but not alone necessary. Franchise is between having a job and create his/her business. It’s a financial partnership with a wellknown company witch duplicate a successfull  concept.
                        </p>
                        <p className="pl-3">
                          MyFRANCHISE Test allows the candidate to assess himself (herself) on eight keys factors of success to be successful in Franchise that is a mix of ability to sell and create (Openness, Adaptability, Decision Making, Ability to manage people, Ability to sell, Organization skills, Ability to run a business, Personal situation).
                        </p>
                        <p className="pl-3 reconmendFontSize">
                          <u>Recommended reading:</u> (Devenir franchisé ou lancer une franchise  – C. Zimmer - Paris 2011 – 3ème édition Ed. Vuibert) recommended by F.F.F (Fédération Française de la Franchise de Paris).
                        </p> */}
                      </div>
                      <div className="indi-list">
                        <FormattedHTMLMessage
                          id="ind.franchise.p.start.test"
                          defaultMessage="<h3 class=''>Start Your Test </h3> <div class='about-text'> <p> Before starting ‘MyFRANCHISE Test’ you can see an example of results exactly as you will get after taking. Your test still totally confidential and we don’t use any named data coming from you for other destination of the test (French Data Authority n°661001){' '}</p></div>"
                        />
                        {/* <h3 className="">Start Your Test </h3>
                        <div className="about-text">
                          <p>
                            Before starting ‘MyFRANCHISE Test’ you can see an
                            example of results exactly as you will get after
                            taking. Your test still totally confidential and we
                            don’t use any named data coming from you for other
                            destination of the test (French Data Authority
                            n°661001){" "}
                          </p>
                        </div> */}

                        <div
                          className="add-width intro_layer mt-5 d-flex"
                          data-animation="fadeIn"
                        >
                          <div className="d-flex m-auto w-100">
                            <div className="d-inline-block w-50">
                              <button
                                onClick={this.openFranchiseExamples.bind(this)}
                                className="btn btn-warning center-block example_button_radius"
                                style={{
                                  backgroundColor: "#191970",
                                  color: "white",
                                }}
                              >
                                <FormattedHTMLMessage
                                  id="ind.happiness.btn.examples"
                                  defaultMessage="SEE EXAMPLE OF RESULTS"
                                />
                              </button>
                            </div>
                            <div className="d-inline-block w-50">
                              <button
                                type="button"
                                className="btn  center-block example_button_radius"
                                onClick={this.openFranchise.bind(this)}
                                style={{
                                  backgroundColor: "#1ca9c9",
                                  color: "white",
                                }}
                              >
                                <FormattedHTMLMessage
                                  id="ind.franchise.btn.start"
                                  defaultMessage="Start MyFRANCHISE Test"
                                />
                              </button>
                            </div>
                            <div className="d-inline-block w-50">
                              <button
                                className="btn btn-warning"
                                style={{
                                  backgroundColor: "#191970",
                                  color: "white",
                                }}
                                onClick={this.buyNowTest.bind(this)}
                              >
                                <FormattedHTMLMessage
                                  id="ind.happiness.btn.first.signed"
                                  defaultMessage="Start Buy Now"
                                />
                                {/* FREE <small>(First Signed)</small> */}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="indi-list">
                        {/* <h3 className=""><FormattedMessage id="price" defaultMessage="Price "/></h3>

                        <div className="row">
                          <div className="col-md-4 col-sm-4 m-auto w100_991">
                            <div className="card text-center mt-4"> */}
                        {/* <div className="card-body">
                                <h4 className="card-title">
                                  <FormattedHTMLMessage id="per.test" defaultMessage="Per Test"/>
                                </h4>
                                <p className="card-text"><i>MyFRANCHISE TEST©</i></p> */}
                        {/* <p className="card-text"><FormattedHTMLMessage id="ind.one.credit" defaultMessage="(or 1 crédit)"/> </p> */}
                        {/* <button className="btn btn-warning" onClick={this.buyNowTest.bind(this)}>
                                <FormattedHTMLMessage id="ind.franchise.frist.signup" defaultMessage="FREE (first signed)"/>
                                </button>
                              </div> */}
                        {/* <button className="btn btn-warning" style={{color:"white",backgroundColor:"#808080"}} onClick={this.buyNowTest.bind(this)}>
                                  <FormattedMessage id="ind.talent.buy.now" defaultMessage="Start Buy Now"/>
                                </button>
                            </div>
                          </div>
                        </div> */}
                        {/* <h3 className="">&nbsp;</h3>
                        <FormattedHTMLMessage id="ind.franchise.pice.detail" defaultMessage="<ul class='indi-ul'> <li>Buy 1 test  (€20/test) = <b>€20</b></li><li>Buy 2 tests (€19/test) = <b>€38</b></li><li>Buy 3 tests (€18/test) = <b>€54</b></li><li>Buy 4 tests (€17/test) = <b>€68</b></li></li><li>Buy FULL SKILLS ASSESSMENT (5 tests + 1 hour of online debreifing) = <b>€350</b></li></ul>"/>
                      </div> */}
                        {/* <h3 className="">&nbsp;</h3>
                        <FormattedHTMLMessage
                          id={userRole === "User" ? "ind.happiness.pice.detail.user" : "ind.happiness.pice.detail"}
                          defaultMessage="<ul class='indi-ul'> <li>Buy 1 test credit = <b>€ 20</b>/test</li><li>Buy 2 test credits = <b>€ 13,5</b>/test</li><li>Buy 3 test credits = <b>€ 12</b>/test</li><li>Buy 4 test credits and more = <b>€ 10</b>/test</li></ul>"
                        /> */}
                         {this.renderIndividualCreditCards()}
                        <h3 className="">&nbsp;</h3>
                        <FormattedHTMLMessage
                          id={userRole === "User" ? "ind.happiness.pice.detail1.user" : "ind.happiness.pice.detail1"}
                          defaultMessage="<ul class='indi-ul'> <li>Buy 1 test credit = <b>€ 20</b>/test</li><li>Buy 2 test credits = <b>€ 13,5</b>/test</li><li>Buy 3 test credits = <b>€ 12</b>/test</li><li>Buy 4 test credits and more = <b>€ 10</b>/test</li></ul>"
                        />
                      </div>
                     
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isSignedIn: state.auth.isSignedIn,
    lang: state.locale.lang,
  };
};

Individual = connect(mapStateToProps, {})(Individual);

export default Individual;
